import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ImageDataDb } from '../_shared/data/image-data-db.data';
import { IButton } from '../_shared/models/button/button.model';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { IInfoBubble } from '../_shared/models/info-bubble.model';
import { IProductHeader } from '../_shared/models/product/product-header.model';
import { IHighlightItem } from '../_shared/models/highlight-item.model';
import { ILink } from '../_shared/models/link.model';
import { MediaImage } from '../_shared/models/media/media-image.model';
import { HeadingType } from '../_shared/types/heading/heading.type';
import { Image } from '../_shared/models/image/image.model';
import { ImageData } from '../_shared/models/image/image-data.model';
import { GridComponent } from '../grid/grid.component';
import { ImageItemComponent } from '../media/media-item/image-item/image-item.component';
import { HighlightedItemComponent } from '../highlighted-item/highlighted-item.component';
import { HeadingComponent } from '../heading/heading.component';
import { InfoBubbleComponent } from '../info-bubble/info-bubble.component';
import { TextHtmlComponent } from '../text-html/text-html.component';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { LinkDirective } from '../_shared/directives/link.directive';
import { CastPipe } from '../_shared/pipes/cast.pipe';

@Component({
    selector: 'sirius-product-header',
    templateUrl: './product-header.component.html',
    styleUrls: ['./product-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        GridComponent,
        ImageItemComponent,
        HighlightedItemComponent,
        HeadingComponent,
        InfoBubbleComponent,
        TextHtmlComponent,
        LinkDirective,
        ButtonComponent,
        CastPipe,
        CommonModule,
    ]
})
export class ProductHeaderComponent implements IDynamicElement, OnInit {
    @Input() title = '';
    //TODO: rename to subtitle
    @Input() subTitle = '';
    @Input() textHtml = '';
    @Input() image?: MediaImage;
    @Input() buttonPrimary?: IButton;
    @Input() buttonSecondary?: IButton;
    @Input() infoBubble?: IInfoBubble;
    @Input() externalLink?: ILink;
    @Input() highlightedItems?: IHighlightItem[];
    @Input() logo?: Image;
    @Input() isCobotPage?: boolean;

    config?: IProductHeader;
    imageData?: ImageData;

    get headingType(): HeadingType {
        return this.isCobotPage ? 'display' : 'title';
    }

    ngOnInit(): void {
        if (this.config) {
            this.title = this.config.title;
            this.subTitle = this.config.subTitle;
            this.textHtml = this.config.textHtml;
            this.image = this.config.image;
            this.buttonPrimary = this.config.buttonPrimary;
            this.buttonSecondary = this.config.buttonSecondary;
            this.infoBubble = this.config.infoBubble;
            this.externalLink = this.config.externalLink;
            this.highlightedItems = this.config.highlightedItems;
            this.logo = this.config.logo;
            this.isCobotPage = this.config.isCobotPage;
        }

        this.imageData = ImageDataDb.productHeader;
    }
}
